export default function ({
  classify = 'STUDENT',
  businessType = 'STUDENT_OFFICIALLY',
  combineCustomFieldProps,
  } = {}) {
  return {
    data () {
      return {
        customFieldList: []
      }
    },
    methods: {
      queryCustomFieldList () {
        !this.editMode && this.showLoading();
        try {
          this.$api.getMemberCustomFieldList ({classify})
            .then(res=> {
              if (res.code === 200) {
                !this.editMode && this.$toast.clear();
                if (combineCustomFieldProps) {
                  this.doCombineCustomFieldProps();
                }
                for (let idx = 0; idx < res.data.length; idx++) {
                  const item = res.data[idx];
                  let displayOpst = {};
                  for (let i = 0; i < item.displayList.length; i++) {
                    if (item.displayList[i].businessType === businessType) {
                      displayOpst = {...item.displayList[i]};
                      break;
                    }
                  }
                  if (!displayOpst.id || !displayOpst.display) continue;
                  let  { fieldName, fieldDataType, selectItemList, id } = item; 
                  this.customFieldList.push({
                    fieldName, 
                    fieldDataType, 
                    selectItemList, 
                    customFieldId: id,
                    required: displayOpst.required, 
                    value: ''
                  });
                }
              }
              if (res.code > 60000) {
                this.toast.fail(res.msg || '网络异常，请稍后重试');
              }
            })
        } catch (err) {
          this.$toast.clear();
        }
      },
      doCombineCustomFieldProps () {
        let { customFieldList } = this;
        let infosCustomFieldList =  this[combineCustomFieldProps].customFieldList;
        if (customFieldList && customFieldList.length && infosCustomFieldList && infosCustomFieldList.length) {
          let customField = {};
          let infosCustomFieldObj = {};
          customFieldList.forEach(v=>{
            customField[v.customFieldId] = v;
          })
          infosCustomFieldList.forEach(v=>{
            infosCustomFieldObj[v.customFieldId] = v;
          })
          for (let prop in infosCustomFieldObj) {
            if (customField[prop]) {              
              customField[prop].value = infosCustomFieldObj[prop].value;
              customField[prop].valueList = infosCustomFieldObj[prop].valueList || [];
            }
          }
          console.log('这是要做整合了')
        }
      }
    },
    created () {
      !this.customFieldEditMode && this.queryCustomFieldList()
    }
  }
}